<script>
/* COMPOSANTS */
import RecapitulatifFacturationAllInclusiveList from '@views/settings/ParametrageCommission/ParametrageCommissionAllInclusiveList';
import RecapitulatifFacturationOnlineList from '@views/settings/ParametrageCommission/ParametrageCommissionOnlineList';
import RecapitulatifFacturationOffer3List from '@views/settings/ParametrageCommission/ParametrageCommissionOffer3List';

/* MIXINS */
import recapitulatifFacturationTabMixin from '@mixins/tab/parametrageCommissionTabMixin';
import GaView from '@components/v2/layout/GaView.vue';
import {useTabStore} from '@store/tabStore';

/* SERVICES */

export default {
  components: {
    GaView,
    RecapitulatifFacturationOnlineList,
    RecapitulatifFacturationAllInclusiveList,
    RecapitulatifFacturationOffer3List,
  },
  mixins: [recapitulatifFacturationTabMixin],
  setup() {},
  head() {
    return {
      title: this.$t('settings.recapitulatif_facturation'),
    };
  },
  data() {
    return {
      tabSelected: undefined,
    };
  },
  computed: {
    activeTab() {
      if (this.tabSelected) return this.tabSelected;
      return 'offer1';
    },
  },
  mounted() {
    this.tabSelected = useTabStore().getTabActive('ParametrageCommissionPage', 'offer1');
  },
  methods: {
    displayTab(tab) {
      console.log(tab);
      useTabStore().setTabActive('ParametrageCommissionPage', tab.id);
      this.tabSelected = tab.id;
    },
  },
};
</script>

<template>
  <GaView>
    <template #content>
      <RecapitulatifFacturationOnlineList v-if="this.isConfort" @tab="this.displayTab" :tabs="this.tabs" />
      <RecapitulatifFacturationAllInclusiveList v-if="this.isPremium" @tab="this.displayTab" :tabs="this.tabs" />
      <RecapitulatifFacturationOffer3List v-if="this.isEssentiel" @tab="this.displayTab" :tabs="this.tabs" />
    </template>
  </GaView>
  <!--
          <AkLoader ref="loader" :message="$t('currently_loading')" :scale="1.5">
            <template #content>
              <GaTabView :firstTab="getFirstTab()" :title="$t('settings.recapitulatif_facturation')" :tabs="tabs">
                <template #offerAllInclusive>
                  <RecapitulatifFacturationAllInclusiveList />
                </template>
                <template #offerOnline>
                  <RecapitulatifFacturationOnlineList />
                </template>
              </GaTabView>
            </template>
          </AkLoader>
        </template> </GaListView></template
  ></GaView>
  -->
</template>
